import { render, staticRenderFns } from "./DesignRirekisho001Preview.vue?vue&type=template&id=37795afb&scoped=true"
import script from "./DesignRirekisho001Preview.vue?vue&type=script&lang=js"
export * from "./DesignRirekisho001Preview.vue?vue&type=script&lang=js"
import style0 from "./DesignRirekisho001Preview.vue?vue&type=style&index=0&id=37795afb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37795afb",
  null
  
)

export default component.exports